import { MAINTENANCE_ENABLED } from '@/app/utils/constants'
import { Page } from '@/types'

export default defineNuxtRouteMiddleware((to) => {
  if (to.name !== 'maintenance' && MAINTENANCE_ENABLED) {
    return navigateTo({ name: Page.Maintenance })
  }

  if (to.name === 'maintenance' && !MAINTENANCE_ENABLED) {
    return navigateTo({ name: Page.Index })
  }
})
